__turbopack_context__.v({
  "heading": "heading-module__pM3uIa__heading",
  "heading1": "heading-module__pM3uIa__heading1",
  "heading2": "heading-module__pM3uIa__heading2",
});
